import { Controller } from "@hotwired/stimulus"

// Filters items and sections in the tax organizer details modal
// Searches both item text and section names
export default class extends Controller {
  static targets = ["input", "clearBtn", "filteredIndicator", "questionItem", "questionSection"]

  filter(event) {
    const filterText = event.target.value.toLowerCase().trim()

    // Show/hide clear button and filtered indicator
    this.clearBtnTarget.style.display = filterText ? 'block' : 'none'
    this.filteredIndicatorTarget.style.display = filterText ? 'inline' : 'none'

    if (filterText === '') {
      this.showAll()
    } else {
      this.filterByText(filterText)
      this.hideSectionsWithoutVisibleItems()
    }
  }

  showAll() {
    this.questionItemTargets.forEach(item => item.style.display = '')
    if (this.hasQuestionSectionTarget) {
      this.questionSectionTargets.forEach(section => section.style.display = '')
    }
  }

  filterByText(filterText) {
    this.questionItemTargets.forEach(item => {
      const searchableText = item.dataset.searchable
      const sectionName = item.dataset.section?.toLowerCase() || ''
      const actorType = item.dataset.actorType?.toLowerCase() || ''

      // Show if matches searchable text, section name, or actor type
      if (searchableText.includes(filterText) || sectionName.includes(filterText) || actorType.includes(filterText)) {
        item.style.display = ''
      } else {
        item.style.display = 'none'
      }
    })
  }

  hideSectionsWithoutVisibleItems() {
    if (!this.hasQuestionSectionTarget) return

    this.questionSectionTargets.forEach(section => {
      const visibleItems = section.querySelectorAll('.question-item:not([style*="display: none"])')
      section.style.display = visibleItems.length > 0 ? '' : 'none'
    })
  }

  clear(event) {
    event.preventDefault()
    this.inputTarget.value = ''
    this.inputTarget.dispatchEvent(new Event('input'))
    this.inputTarget.focus()
  }

  reset() {
    // Called when modal closes
    if (this.hasInputTarget) {
      this.inputTarget.value = ''
      this.inputTarget.dispatchEvent(new Event('input'))
    }
  }
}
